export const isAutoPayCheckboxValid = form => {
  var _form$values, _form$values2;
  return !(!(form !== null && form !== void 0 && (_form$values = form.values) !== null && _form$values !== void 0 && _form$values.savePaymentDetails) && Boolean(form === null || form === void 0 ? void 0 : (_form$values2 = form.values) === null || _form$values2 === void 0 ? void 0 : _form$values2.saveAutoPay));
};